export const LIMIT_PRODUCT_REMAINING = 20;
